import { render, staticRenderFns } from "./sga.vue?vue&type=template&id=aa8a13d0&scoped=true"
import script from "./sga.vue?vue&type=script&lang=js"
export * from "./sga.vue?vue&type=script&lang=js"
import style0 from "./sga.vue?vue&type=style&index=0&id=aa8a13d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8a13d0",
  null
  
)

export default component.exports